import React from "react";
import cover from "./image/cover-front.png";
import coverback from "./image/cover-back.png";

// Import all images
import img97 from "./image/A4 - 97.png";
import img108 from "./image/A4 - 108.png";
import img68 from "./image/A4 - 68.png";
import img66 from "./image/A4 - 66.png";
import img103 from "./image/A4 - 103.png";
import img87 from "./image/A4 - 87.png";
import img102 from "./image/A4 - 102.png";
import img84 from "./image/A4 - 84.png";
import img65 from "./image/A4 - 65.png";
import img82 from "./image/A4 - 82.png";
import img80 from "./image/A4 - 80.png";
import img111 from "./image/A4 - 111.png";
import img83 from "./image/A4 - 83.png";
import img78 from "./image/A4 - 78.png";
import img71 from "./image/A4 - 71.png";
import img79 from "./image/A4 - 79.png";
import img70 from "./image/A4 - 70.png";
import img60 from "./image/A4 - 60.png";
import img51 from "./image/A4 - 51.png";
import img61 from "./image/A4 - 61.png";
import img104 from "./image/A4 - 104.png";
import img110 from "./image/A4 - 110.png";
import img57 from "./image/A4 - 57.png";
import img52 from "./image/A4 - 52.png";
import img114 from "./image/A4 - 114.png";
import img100 from "./image/A4 - 100.png";
import img56 from "./image/A4 - 56.png";
import img120 from "./image/A4 - 120.png";
import img119 from "./image/A4 - 119.png";
import img3 from "./image/A4 - 3.png";

// Import all text components
import { PoemSuperBlue } from "./texts/super_blue";
import { PoemInsertYourNameHere } from "./texts/insert_your_name_here";
import { PoemFactorySettings } from "./texts/factory_settings";
import { PoemPOV } from "./texts/pov";
import { PoemSunlightReflectingInPuddles } from "./texts/sunlight_reflecting_in_puddles";
import { PoemOnAccidents } from "./texts/on_accidents";
import { PoemCapitalizeOnThis } from "./texts/capitalize_on_this";
import { PoemDyingMothOnTheTramFloor } from "./texts/dying_moth_on_the_tram_floor";
import { PoemAlienSoil } from "./texts/alien_soil";
import { PoemAntiInfantry } from "./texts/anti_infantry";
import { PoemCrossfire } from "./texts/crossfire";
import { PoemLies } from "./texts/lies";
import { PoemNewTextDocument } from "./texts/new_text_document";
import { PoemFullOfLife } from "./texts/full_of_life";
import { PoemDistance } from "./texts/distance";
import { PoemPushAndPull } from "./texts/push_and_pull";
import { PoemTheScripture } from "./texts/the_scripture";
import { PoemEmergencyManeuvers } from "./texts/emergency_maneuvers";
import { PoemFiftyFiftyFiftyFifty } from "./texts/fifty_fifty_fifty_fifty";
import { PoemRacehorse } from "./texts/racehorse";
import { PoemGraphPaperMoment } from "./texts/graph_paper_moment";
import { PoemExpectations } from "./texts/expectations";
import { PoemDomestic } from "./texts/domestic";
import { PoemTimeskip } from "./texts/timeskip";
import { PoemMillion } from "./texts/million";
import { PoemCountYourBlessings } from "./texts/count_your_blessings";

interface Page {
    isImage: boolean;
    title?: string;
    text?: React.ReactNode;
    image?: React.ReactNode;
}

const pages: Page[] = [
    {
        isImage: false,
        text: <div id="" className=""></div>,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={cover} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "super blue",
        text: <PoemSuperBlue />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img97} alt="" />
            </div>
        ),
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img108} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "insert your name here",
        text: <PoemInsertYourNameHere />,
    },
    {
        isImage: false,
        title: "factory settings",
        text: <PoemFactorySettings />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img68} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "P.O.V.",
        text: <PoemPOV />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img66} alt="" />
            </div>
        ),
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img103} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "sunlight reflecting in puddles",
        text: <PoemSunlightReflectingInPuddles />,
    },
    {
        isImage: false,
        title: "on accidents",
        text: <PoemOnAccidents />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img87} alt="" />
            </div>
        ),
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img102} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "Capitalize (on) This",
        text: <PoemCapitalizeOnThis />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img83} alt="" />
            </div>
        ),
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img78} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "dying moth on the tram floor",
        text: <PoemDyingMothOnTheTramFloor />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img84} alt="" />
            </div>
        ),
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img65} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "alien soil",
        text: <PoemAlienSoil />,
    },
    {
        isImage: false,
        title: "anti infantry",
        text: <PoemAntiInfantry />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img82} alt="" />
            </div>
        ),
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img80} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "crossfire",
        text: <PoemCrossfire />,
    },
    {
        isImage: false,
        title: "#ffffff lies",
        text: <PoemLies />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img111} alt="" />
            </div>
        ),
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img71} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "new text document",
        text: <PoemNewTextDocument />,
    },
    {
        isImage: false,
        title: "full of life",
        text: <PoemFullOfLife />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img79} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "distance",
        text: <PoemDistance />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img70} alt="" />
            </div>
        ),
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img60} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "push and pull",
        text: <PoemPushAndPull />,
    },
    {
        isImage: false,
        title: "the scripture",
        text: <PoemTheScripture />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img51} alt="" />
            </div>
        ),
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img56} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "timeskip",
        text: <PoemTimeskip />,
    },
    //image 120
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img120} alt="" />
            </div>
        ),
    },
    //image 119
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img119} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "emergency maneuvers",
        text: <PoemEmergencyManeuvers />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img61} alt="" />
            </div>
        ),
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img104} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "50-50-50-50",
        text: <PoemFiftyFiftyFiftyFifty />,
    },
    {
        isImage: false,
        title: "racehorse",
        text: <PoemRacehorse />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img110} alt="" />
            </div>
        ),
    },
    //image 52
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img52} alt="" />
            </div>
        ),
    },
    //poem million
    {
        isImage: false,
        title: "million",
        text: <PoemMillion />,
    },
    {
        isImage: false,
        title: "graph paper moment",
        text: <PoemGraphPaperMoment />,
    },
    // img 3
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img3} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "expectations",
        text: <PoemExpectations />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img57} alt="" />
            </div>
        ),
    },

    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img114} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        title: "domestic",
        text: <PoemDomestic />,
    },
    // poem count your blessings
    {
        isImage: false,
        title: "count your blessings",
        text: <PoemCountYourBlessings />,
    },
    {
        isImage: true,
        image: (
            <div id="" className="">
                <img className="" src={img100} alt="" />
            </div>
        ),
    },
    {
        isImage: false,
        text: (
            <div id="054" className=" lastPage">
                <p className=" ">
                    <span className="Poem-Text">Poems for Androids</span>
                </p>
                <p className=" ">
                    <span className="Poem-Text">Octav Codrea</span>
                </p>
                <p className=" ">
                    <span className="Poem-Text">2025</span>
                </p>
            </div>
        ),
    },
    {
        isImage: false,
        text: <div id="054" className=""></div>,
    },
];

export default pages;
